import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';

export const StyledStack = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  gap: '50px',
  width: '100vw',
  minHeight: '100vh',
  '& .MuiTypography-root': { textAlign: 'center' },
  svg: {
    [theme.breakpoints.up('xs')]: {
      maxHeight: '45vh'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '75vw'
    },
    width: 'auto',
    height: 'auto'
  }
}));



// WEBPACK FOOTER //
// ./src/containers/NotFound/styles.js